import React from 'react'

import { Link } from 'react-router'

const NavHighlighter = (props) => {
  const {
    pathname,
    to,
    children,
    className,
    style,
    noli,
  } = props

  const isActive = to.split('/')[1] === pathname.split('/')[1]

  const current = isActive
    ? 'active'
    : ''

  const customCLass = className
    ? `${className} ${current}`
    : `${current}`

  const selectedArrow = isActive
    ? <span className="selected" />
    : ''

  const styles = style || {}

  const returned = noli
    ? (<Link to={to} className={customCLass} style={styles}>
      {children}
      {selectedArrow}
    </Link>)
    : (<li className={customCLass}>
      <Link to={to} className={current}>
        {children}
        {selectedArrow}
      </Link>
    </li>)

  return (returned)
}

export default NavHighlighter
